import React from 'react';
import { CTAButton } from './CTAButton';
export function BenefitSection() {
  return <section className="w-full bg-white py-14 px-4 border-t border-gray-200" data-id="element-36">
      <div className="max-w-2xl mx-auto text-center" data-id="element-37">
        <h2 className="text-3xl md:text-4xl font-black text-black leading-tight mb-6" data-id="element-38">
          Acompañar a tu hijo{' '}
          <span className="bg-yellow-200 px-1" data-id="element-39">
            no debería ser una lucha diaria
          </span>
        </h2>

        <p className="text-xl md:text-2xl font-bold text-gray-700 mb-10 leading-relaxed" data-id="element-40">
          Cuando entendés cómo ayudarlo, todo cambia. No solo en la escuela…
          también en el vínculo.
        </p>

        <CTAButton text="👉 QUIERO AYUDAR A MI HIJO HOY" href="#compra" className="w-full" data-id="element-41" />
      </div>
    </section>;
}